import React from "react";

const AuthLayout = ({ children }) => {
  return (
    <div className="full-layout">
      {children}
    </div>
  );
};

export default AuthLayout;